// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Sort = createIcon(
  <path
    clipRule="evenodd"
    d="M9.24519 9.8489C8.89371 10.2004 8.32386 10.2004 7.97239 9.8489C7.62092 9.49742 7.62092 8.92758 7.97239 8.5761L11.364 5.1845C11.7155 4.83303 12.2853 4.83303 12.6368 5.1845L16.0284 8.5761C16.3799 8.92758 16.3799 9.49742 16.0284 9.8489C15.6769 10.2004 15.1071 10.2004 14.7556 9.8489L12.0004 7.09369L9.24519 9.8489ZM9.24489 15.8257C8.89342 15.4742 8.32357 15.4742 7.9721 15.8257C7.62063 16.1772 7.62063 16.747 7.9721 17.0985L11.3637 20.4901C11.7152 20.8416 12.285 20.8416 12.6365 20.4901L16.0281 17.0985C16.3796 16.747 16.3796 16.1772 16.0281 15.8257C15.6766 15.4742 15.1068 15.4742 14.7553 15.8257L12.0001 18.5809L9.24489 15.8257Z"
    fillRule="evenodd"
  />,
);
